module.exports = __webpack_public_path__ + "static/media/02.ec75f7ff.jpg";